<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span epub:type="pagebreak" id="page_viii" title="viii"><i>This book is dedicated to the broken and hurting, the wounded and rejected, the silent sufferers who hide in pulpits and corner offices with their name on the door. This book has a message that will lead you on a journey from brokenness to wholeness and emotional healthiness.</i></span></p>
<p class="ded1"><i>I have prayed for you as I have written this book; a prayer for God to bring healing to every hurt and broken place in your life. This book is a hand that is extended to those who feel lost and forgotten in the brokenness of their stories. Your wounds are going to heal and become whole. From your scars will come a story to aid in the healing of others. You will discover that Jesus glows in the dark places of your life and that broken crayons get to color.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4806283c